/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gd_Discord_CtaInputs */

const en_gd_discord_cta = /** @type {(inputs: Gd_Discord_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the Discord community`)
};

const id_gd_discord_cta = /** @type {(inputs: Gd_Discord_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gabung komunitas Discord`)
};

/**
* | output |
* | --- |
* | "Join the Discord community" |
*
* @param {Gd_Discord_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const gd_discord_cta = /** @type {((inputs?: Gd_Discord_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gd_Discord_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_gd_discord_cta(inputs)
	return en_gd_discord_cta(inputs)
});